import type { AccountStatus } from '@/types/auth';

// Statuses where the member is no longer an active collaborator and any
// surface that renders their name should make that visible (strikethrough,
// muted suffix, etc.). Banned / failed / deleted all qualify; pre_banned
// is legacy and intentionally excluded.
export const INACTIVE_ACCOUNT_STATUSES: readonly AccountStatus[] = [
  'banned',
  'failed',
  'deleted',
];

export function isInactiveAccountStatus(
  status: AccountStatus | undefined
): boolean {
  return !!status && INACTIVE_ACCOUNT_STATUSES.includes(status);
}

export const INACTIVE_ACCOUNT_STATUS_LABELS: Record<string, string> = {
  banned: 'Game over',
  failed: 'Fallido',
  deleted: 'Archivado',
};
